import * as React from 'react';
import ReactRangeSlider from 'react-rangeslider';
import { compose, pure, withHandlers } from 'recompose';
import Grid from '@material-ui/core/Grid';
import { NumberInput } from '../NumberInput';
import toNumber from 'lodash/toNumber';
import clamp from 'lodash/clamp';
class Slider extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            value: toNumber(props.value || 0),
        };
        this.changeHandler = this.changeHandler.bind(this);
    }
    changeHandler(event) {
        const { min = 0, max = 100, shifting = false } = this.props;
        let value = event.target ? event.target.value : event;
        if (shifting) {
            while (Number(value) > max) {
                value = String(value).substr(1);
            }
        }
        value = clamp(toNumber(value), min, max).toString();
        this.setState({ value: Number(value) });
        this.props.handleChange(Number(value));
    }
    render() {
        const { value } = this.state;
        const { handleChange, input, inputPostLabel, inputWidth = 70, label, value: propsValue, ...componentProps } = this.props;
        const { min = 0, max = 100, labels = { 0: '0', 100: '100' }, onChange: _onChange, ...otherComponentProps } = componentProps;
        const currentValue = propsValue !== undefined ? propsValue : value;
        const testId = this.props.testId || 'Slider';
        return (React.createElement("div", { "data-testid": `${testId}` },
            React.createElement(Grid, { container: true, alignItems: "center" },
                React.createElement(Grid, { item: true, xs: true }, label),
                input ? (React.createElement(Grid, { item: true, style: { width: inputWidth } },
                    React.createElement(NumberInput, { "data-testid": `${testId}-input`, input: { onChange: this.changeHandler }, inputProps: {
                            max,
                            min,
                            type: 'number',
                        }, postLabel: inputPostLabel, value: currentValue }))) : null,
                React.createElement(Grid, { item: true, xs: 12 },
                    React.createElement(ReactRangeSlider, Object.assign({ "data-testid": `${testId}-input`, labels: labels, max: max, min: min, onChange: this.changeHandler, value: currentValue }, otherComponentProps))))));
    }
}
const ComposedSlider = compose(pure, withHandlers({
    handleChange: ({ onChange }) => (value) => {
        if (typeof onChange === 'function') {
            onChange(value);
        }
    },
}))(Slider);
ComposedSlider.displayName = 'Slider';
export default ComposedSlider;
//# sourceMappingURL=Slider.js.map